import { roundOfNumber } from "./intl.js"

export const calculateSelllingMarginPercent = (value, total) => {
    if (total === 0) {
        return 0
    }
    return roundOfNumber(((1 - (total / value)) * 100), 3)
}
